<template>
	<div class="list-item-search">
		<div class="itemSearch">
			<span v-if="!textshow" @click="showSearch()">搜索</span>
			<div v-else class="search2">
				<p>
					<input type="text" :placeholder="colname+'内搜索'" v-model="keyword" @focus="showsug(1)"
						@keyup="showsug(0)" @blur="hidesug()" @keypress.enter="searchClick()" />
					<i id="eClose" v-show="keyword" @click="clearword()"></i>
					<input type="button" value="搜索" class="searchBtn2" @click="searchClick()" />
				</p>
				<input type="button" value="关闭" @click="closeSearch()" class="close1" />
				<div class="search_dropdown" v-show="showsugflag&&sugwordsList.length">
					<ul class="hotkeywords">
						<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item)">
							<btn
								v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')">
							</btn>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div v-if="resultshow">
			<div v-if="(searchword&&totalResultCount)||loadingMask" v-loading="loadingMask">
				<div class="Tabnav_box">
					<!-- Tabnav_box -->
					<div class="Tabnav_box_L">
					</div>
					<div class="Tabnav_box_R2">

						<div id="datePanelDiv" class="Tabnav_out" name="Tabnav_out" @click="showDatePanel()">
							<!-- Tabnav_out -->
							<div class="Tabnav_screen2" name="Tabnav_screen">{{dateTypeText}}<img
									:src="datePanelVisible?'/images/dIcon.png':'/images/down.png'" style="margin-left: 10px;" /></div>
							<!-- <el-collapse-transition> -->
							<ul class="Tabnav1" name="Tabnav" style="right: 0;" v-show="datePanelVisible">
								<li @click.stop="dateClick(0,'时间不限')" :class="dateType==0?'on':''">时间不限</li>
								<li @click.stop="dateClick(1,'一周内')" :class="dateType==1?'on':''">一周内</li>
								<li @click.stop="dateClick(2,'一月内')" :class="dateType==2?'on':''">一月内</li>
								<li @click.stop="dateClick(3,'一年内')" :class="dateType==3?'on':''">一年内</li>
								<li @click.stop="dateClick(4,'自定义')" :class="dateType==4?'on':''">
									<div>自定义</div>
									<div class="" v-on:click.stop>
										<el-date-picker v-model="dateStr" type="daterange" value-format="yyyy-MM-dd"
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
											@change="dateClick(4,'自定义')">
										</el-date-picker>
									</div>
								</li>

							</ul>
							<!-- </el-collapse-transition> -->
						</div><!-- /Tabnav_out -->

					</div>
				</div><!-- /Tabnav_box -->
				<div id="con_a_1">
					<ul class="searchList">
						<li v-for="(result,index) in resultDataList" :key="result.id">
							<router-link target="_blank" @click.native="$track([['pagetype',colname+'-栏目内搜索-关键词:'+searchword+'-第'+pageNum+'页-第'+(index+1)+'篇-点击']])"
								:to="{ name: 'detail', params: { id: result.id }, query:{ key: searchword }}">
								<span v-html="result.title.replace(/color:Red/g,'color:#2C68FF;')"></span>
								<i></i>
							</router-link>

							<p v-if="result.content&&result.content.indexOf('.pdf</attachment>')>-1">
								<span v-html="result.summary"></span>
							</p>

							<p
								v-else-if="resultHitList[index]&&resultHitList[index].hitPara&&resultHitList[index].hitPara.length>0">
								<span
									v-html="resultHitList[index].hitPara[0].text.replace(/color:Red/g,'color:#2C68FF;')"></span>
							</p>

							<p v-else style="margin-bottom: 16px;">

							</p>

							<em>{{result.publishtime?result.publishtime.substring(0,10):''}}
							</em>
						</li>

					</ul>
					<div class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
							:current-page="pageNum" :page-sizes="[10, 15, 20]" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="totalResultCount">
						</el-pagination>
					</div>
				</div>
			</div>
			<!-- 检索无数据 开始-->
			<div class="emp" v-else>
				<img src="/images/no1.png" />
				<p>抱歉~暂无数据，可尝试更换关键字~</p>
			</div>
			<!-- 检索无数据 结束-->
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				textshow: true,
				resultshow: false,
				showsugflag: false,
				sugstaytimer: '',
				sugwordsList: [],
				loadingMask: false,
				searchType: '1',
				searchColum: '',
				searchword: '',
				keyword: '',
				cachekeyword: '',
				pageNum: 1,
				pageSize: 10,
				totalResultCount: '',
				resultDataList: [],
				resultHitList: [],
				datePanelVisible: false,
				dateType: 0,
				dateTypeText: '时间不限',
				searchdate: '',
				dateStr: ''
			}
		},
		props: [
			'colid',
			'colname',
		],
		mounted: function() {

		},
		watch: {

		},
		methods: {
			showSearch: function() {
				this.textshow = true;
				this.$track([
					['pagetype',this.colname+'-栏目内检索-点击'],
				]);
			},
			showSearchResult: function() {
				this.resultshow = true;
				this.$emit('searchshow');
			},
			closeSearch: function() {
				this.clearword();
				this.textshow = false;
				this.resultshow = false;
				this.$emit('searchclose');
			},
			clearword: function() {
				this.keyword = '';
				this.cachekeyword = '';
			},
			showsug: function(fromflag) {
				if (this.keyword) {
					if (this.cachekeyword != this.keyword) {
						this.getsugfnc();
						this.showsugflag = true;
					}
					if(fromflag){
						this.showsugflag = true;
					}
				} else {
					this.cachekeyword = '';
					this.showsugflag = false;
				}
			},
			hidesug: function() {
				this.showsugflag = false;
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword = this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							// debugger;
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function() {
								if (_this.showsugflag && _this.sugwordsList.length > 0) {
									_this.$track([
										['pagetype', 'sug提示'],
										['searchkeyword', _this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if (_this.sugwordsList.length < 1) {
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			showDatePanel: function() {
				this.$track([
					['pagetype',this.colname+'-栏目内检索-时间筛选-点击'],
				]);
				this.datePanelVisible = true;
				let _this = this;
				var listenerfunc = function(e) {
					if (!document.getElementById('datePanelDiv').contains(e.target)) {
						_this.datePanelVisible = false;
						document.removeEventListener('click', listenerfunc);
					}
				}
				document.addEventListener('click', listenerfunc)
			},
			dateClick(value, name) {
				// debugger
				if (value == 4 && !this.dateStr) {
					return false;
				}
				this.dateType = value;
				this.dateTypeText = name;
				this.datePanelVisible = false;
				this.pageNum = 1;
				if(this.dateType==4){
					this.$track([
						['pagetype',this.colname+'-栏目内检索-时间筛选-自定义:'+this.dateStr[0] + '#' + this.dateStr[1]+'-点击'],
					]);
				}
				else{
					this.$track([
						['pagetype',this.colname+'-栏目内检索-时间筛选-'+this.dateTypeText+'-点击'],
					]);
				}
				this.searchfnc();
			},
			selhistory: function(key) {
				this.keyword = key;
				this.searchClick();
			},
			searchClick: function() {
				this.searchword = this.keyword;
				this.$track([
					['pagetype', this.colname + '栏目搜索'],
					['searchkeyword', this.searchword]
				]);
				if (this.searchword) {
					this.searchColum = this.colid;
					this.pageNum = 1;
					this.pageSize = 10;
					this.dateType = 0;
					this.dateTypeText = '时间不限';
					this.searchfnc();
					this.showSearchResult();
					this.hidesug();
				}
			},
			searchfnc: function() {
				// debugger
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/DEconSearchListInfo',
						responseType: 'json',
						params: {
							lstkey: this.searchword,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							ColID: this.searchColum,
							dateType: this.dateType,
							dateStr: (this.dateType == 4 && this.dateStr && this.dateStr.length > 1) ? (this
								.dateStr[0] + '#' + this.dateStr[1]) : '',
						},
					})
					.then(function(response) {
						if (response.data.data) {
							_this.resultDataList = response.data.data.data?response.data.data.data.tempResult.artLst:[];
							_this.resultHitList = response.data.data.data?response.data.data.data.tempResult.dataList:[];
							_this.totalResultCount = response.data.data.data?response.data.data.data.tempResult.totalCount:0;
							if (_this.totalResultCount == 0) {
								_this.$track([
									['pagetype', _this.colname + '栏目搜索为空'],
									['searchkeyword', _this.searchword]
								]);
							}
						} else {

						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
		}
	}
</script>

<style>
</style>
